import {analyticsLogEvent} from '../api'
import {ProductImpression} from '_types'

const eventName = 'addToCart'

interface Parameters {
    currencyCode: string
    list: string
    product: Omit<ProductImpression, 'list'>
}

/**
 * Tracks a product added to cart.
 *
 * @param {Parameters} params - Object containing the product details.
 * @param {string} params.currencyCode - The currency code being used.
 * @param {string} params.list - List parameter
 * @param {Omit<ProductImpression, 'list'>} params.product - Product parameter
 */
export function analyticsEventAddToCart({currencyCode, list, product}: Parameters): void {
    const eventDetails = {
        ecommerce: {
            currencyCode: currencyCode,
            add: {
                actionField: {
                    list: list,
                },
                products: [product],
            },
        },
    }

    analyticsLogEvent(eventName, eventDetails)
}
